import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NrrConvertedTwoController from "./nrr_converted_two_controller"
application.register("nrr-converted-two", NrrConvertedTwoController)

import ClickOpenController from "./click_open_controller"
application.register("click-open", ClickOpenController)

import NavHighlightController from "./nav_highlight_controller"
application.register("nav-highlight", NavHighlightController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)
